import React from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import {
  VictoryAxis,
  VictoryChart,
  VictoryLine,
  VictoryScatter,
  VictoryVoronoiContainer,
} from 'victory';
import { ecpGraphicsLegend } from '../../utils/helpers/view/ecpDetailHelper';

type VictoryScatterProps = {
  height: number;
  width: number;
  data: [];
  legend: string[];
  lineData: {
    slope: number;
  };
  colorsLegend: string[];
};
export default function VictoryScatterComponent({
  height,
  width,
  data,
  legend,
  lineData,
  colorsLegend,
}: VictoryScatterProps) {  
  return (    
    <>
      <VictoryChart
        height={height}
        width={width}
        containerComponent={
          <VictoryVoronoiContainer
            labels={(datum) => parseFloat(datum.datum.x.toFixed(2)).toString()}
          />
        }
      >
        <VictoryScatter
          style={{ data: { fill: '#008BD2' } }}
          size={7}
          data={data}
        />
        {/* y axis */}
        <VictoryAxis
          standalone={false}
          label='Pluie (mm/jour)'
          style={{
            axis: {
              strokeWidth: 1,
            },
            axisLabel: {
              padding: 30,
            },
            ticks: { stroke: 'grey', size: 5 },
          }}
          tickFormat={(t) => `${t}`}
        />
        {/* x axis */}
        <VictoryAxis
          dependentAxis
          standalone={false}
          style={{
            axis: {
              stroke: 'grey',
              strokeWidth: 2,
            },
            axisLabel: {
              padding: 55,
            },
            grid: {
              stroke: '#818e99',
              strokeWidth: 0.5,
              strokeDasharray: '2,4',
            },
            tickLabels: {
              fill: '#232323',
              fontWeight: 400,
              fontSize: 12,
            },
          }}
          label='Survolume (m³/jour)'
          tickFormat={(t) => `${t}`}
        />
        {lineData.slope !== null && <VictoryLine y={(d) => ((lineData.slope * d.x))} />}
        {/* legend */}
      </VictoryChart>
      <Container
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginRight: '20px',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        {ecpGraphicsLegend(colorsLegend, legend)}
      </Container>
    </>
  );
}
